/* VialArt / VialCase — lift the QR Code Link field to where customers can
   find it. With a large gallery, the step-2 field card sits far below the
   fold and the QR input was effectively undiscoverable.
   - VialArt: va-flow2.js builds #va-f2-wrap (the top-wizard block holding the
     exp-date + custom-text questions). Append the QR field there, so it sits
     in the wizard flow right before the design gallery.
   - VialCase (no va-flow2): move the QR field to the FIRST row of the step-2
     card so it leads the personalization fields.
   applyFields() keeps toggling the field per design (lookup is by id, works
   on moved nodes — same mechanism flow2 uses for exp/lot). Identical file
   ships to BOTH themes. */
(function () {
  var done = false, tries = 0;
  function hasFlow2() {
    return !!document.querySelector('script[src*="va-flow2"]');
  }
  function lift() {
    if (done) return true;
    var fld = document.getElementById('va-qr-fld');
    if (!fld) return false;
    var wrap = document.getElementById('va-f2-wrap');      // VialArt (flow2)
    if (wrap) {
      if (fld.parentNode !== wrap) wrap.appendChild(fld);
      done = true;
      return true;
    }
    if (hasFlow2()) return false;   // flow2 present but wrap not built yet — keep waiting
    // VialCase: no flow2 — put the QR row first in the step-2 card
    var card = document.querySelector('.va-step[data-step="2"] .va-card');
    if (card) {
      var firstRow = card.querySelector('.va-frow');
      var row = fld.closest('.va-frow');
      if (firstRow && row && row !== firstRow) {
        // move ONLY the qr field, not its former row-mates (lot/exp)
        firstRow.parentNode.insertBefore(fld, firstRow);
        fld.style.marginBottom = '12px';
      }
      done = true;
      return true;
    }
    return false;
  }
  (function tick() {
    if (lift() || tries++ > 60) return;   // flow2 builds the wrap late; retry ~15s
    setTimeout(tick, 250);
  })();

  /* REQUIRE a QR link on QR designs before add-to-cart. Without it the label
     prints with the default vialart.com QR - a real customer carted that.
     2026-07-23: ALSO cap the link length. Long URLs force a dense QR (more
     modules) and at the printed 8.4mm size the codes DON'T SCAN — customers
     were pasting huge tracking/affiliate links. 60 chars ≈ QR version-4
     byte capacity at ECC M, the densest that reliably scans at label size.
     Never maxlength/truncate — a silently-cut URL would PRINT a broken link. */
  var QR_MAX = 60;
  function qrProblem() {
    var sel = window.sel;
    if (!sel || !sel.fields || sel.fields.indexOf('qr') < 0) return '';  // not a QR design
    var qi = document.getElementById('va-qr');
    if (!qi) return '';
    var fld = document.getElementById('va-qr-fld');
    if (fld && fld.offsetParent === null) return '';   // field hidden (other modes)
    var v = (qi.value || '').replace(/^\s+|\s+$/g, '');
    // "Remove QR code" in the va-flow2 sheet (2026-09-30) settles it for this design: prints without the code
    if (!v) return (window.vaNoQr && window.vaNoQr === sel.key) ? '' : 'missing';
    if (v.length > QR_MAX) return 'toolong';
    return '';
  }
  /* live hint under the field while typing/pasting */
  function hintEl() {
    var h = document.getElementById('va-qr-lenhint');
    if (h) return h;
    var fld = document.getElementById('va-qr-fld');
    if (!fld) return null;
    h = document.createElement('div');
    h.id = 'va-qr-lenhint';
    h.style.cssText = 'display:none;margin-top:6px;font-size:12px;line-height:1.45;font-weight:700;color:#f87171;';
    fld.appendChild(h);
    return h;
  }
  function syncHint() {
    var qi = document.getElementById('va-qr');
    var h = hintEl();
    if (!qi || !h) return;
    var n = (qi.value || '').replace(/^\s+|\s+$/g, '').length;
    if (n > QR_MAX) {
      h.innerHTML = 'This link is too long to scan at label size (' + n + '/' + QR_MAX +
        ' characters). Shorten it free at <b>tinyurl.com</b> or <b>bit.ly</b> and paste the short link.';
      h.style.display = 'block';
    } else {
      h.style.display = 'none';
    }
  }
  (function bindHint(n) {
    var qi = document.getElementById('va-qr');
    if (!qi) { if ((n || 0) < 80) setTimeout(function () { bindHint((n || 0) + 1); }, 250); return; }
    qi.addEventListener('input', syncHint);
    qi.addEventListener('change', syncHint);
    syncHint();
  })(0);
  function nudge(kind) {
    if (typeof window.toast === 'function') {
      window.toast(kind === 'toolong'
        ? 'QR link too long to scan - shorten it at tinyurl.com and paste the short link'
        : 'Add your QR code link first - this design prints a scannable QR');
    }
    var fld = document.getElementById('va-qr-fld');
    if (fld) {
      try { fld.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      fld.style.transition = 'box-shadow .25s';
      fld.style.boxShadow = '0 0 0 3px rgba(248,113,113,.75)';
      setTimeout(function () { fld.style.boxShadow = ''; }, 1800);
      syncHint();
      var qi = document.getElementById('va-qr');
      if (qi) setTimeout(function () { try { qi.focus(); } catch (e) {} }, 450);
    }
  }
  document.addEventListener('click', function (e) {
    try {
      var trig = e.target && e.target.closest && e.target.closest('#va-buy, .va-buy2, #va-mbar-btn, #va-mconfirm');
      if (!trig) return;
      var prob = qrProblem();
      if (!prob) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var ov = document.querySelector('.va-modal.show, #va-modal.show');
      if (trig.id === 'va-mconfirm' && ov) {
        var x = ov.querySelector('.va-mx, .va-modal-x, [aria-label="Close"]');
        if (x) x.click();
      }
      // VialArt: ask in a sheet (paste the link or remove the QR). VialCase has no sheet -> toast nudge.
      if (prob === 'missing' && typeof window.vaQrSheet === 'function') { window.vaQrSheet(trig.id === 'va-mconfirm' ? document.getElementById('va-buy') : trig); return; }
      nudge(prob);
    } catch (err) {}
  }, true);
})();
